import { Button } from '@repo/ui/components/button';
import { Link } from '@tanstack/react-router';
import { ArrowRight, Gift, List, Users } from 'lucide-react';

import { landingContent } from '@/constants/landing-content';

const { solution } = landingContent;

const iconMap = {
  List,
  Users,
  Gift,
} as const;

export function SolutionSection() {
  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto max-w-6xl px-4">
        <h2 className="text-foreground text-center text-3xl font-bold tracking-tight md:text-4xl">
          {solution.headline}
        </h2>

        <div className="mt-12 flex flex-col items-center justify-center gap-4 md:flex-row md:gap-8">
          {solution.steps.map((step, index) => {
            const Icon = iconMap[step.icon as keyof typeof iconMap];
            return (
              <div key={index} className="flex items-center gap-4 md:gap-8">
                <div className="flex flex-col items-center text-center">
                  <div className="bg-primary/10 flex h-16 w-16 items-center justify-center rounded-full">
                    <Icon className="text-primary h-8 w-8" />
                  </div>
                  <p className="text-foreground mt-4 max-w-[200px] text-sm">
                    {step.text}
                  </p>
                </div>
                {index < solution.steps.length - 1 && (
                  <ArrowRight className="text-muted-foreground hidden h-6 w-6 md:block" />
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <Button asChild size="lg" className="text-base">
            <Link to="/registration">{solution.cta}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
